module.exports = __webpack_public_path__ + "img/collection-memoireRingsConfigurator@2x.a5303b1.webp";